<template>
  <div class="text-center">
    <img src="~assets/img/logo.png" class="logo d-none d-sm-inline d-xl-inline" width="192">

    <div class="browser">
        <div class="controls">
          <i></i>
          <i></i>
          <i></i>
        </div>
      
        <div class="eye"></div>
        <div class="eye"></div>
        <div class="mouth">
          <div class="lips"></div>
          <div class="lips"></div>
          <div class="lips"></div>
          <div class="lips"></div>
          <div class="lips"></div>
          <div class="lips"></div>
          <div class="lips"></div>
          <div class="lips"></div>
        </div>
    </div>

    <h1>Oops! Endereço incompleto...</h1>
    <p>
      Para acessar essa página você deve fornecer a <i>URL</i> da sua clínica de medicina do Trabalho.
    </p>

    <p v-if="url" style="word-wrap: break-word;">
      Por exemplo: <i><b>{{url}}/<span style="color:red">url-da-clinica</span></b></i>
    </p>

  <!-- 404 text -->
  <!--
  <h1>Unfortunately, this page does not exist.</h1>
  <p>The link you clicked may be broken or the page may have been removed.</p>
  -->
  </div>
</template>

<script>
import Fct from 'common/fct'

export default {
  components: {},
  mixins: [Fct],
  data() {
    return {
      url:null
    };
  },

  created() {
    $('body').addClass('bg-login');
    this.url = this.getLocation('origin');
  },

  mounted() {
    $(".carregando").hide();
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
  @import "~assets/styles/error.scss";
</style>


// WEBPACK FOOTER //
// 511.vue?a93c9ce8